module.exports = __webpack_public_path__ + "bloggeri_header.efb7105c65fcbd1658ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bloggeri_header.png
// module id = 660
// module chunks = 2